










import { Component, VModel, Vue } from "vue-property-decorator";

@Component({
  name: "UserMenu",
})
export default class UserMenuMobileDialog extends Vue {
  @VModel({ required: true, type: Boolean, default: false })
  isShowed!: boolean;
}
